import { createType } from '../../utils/helpers';
import { generateTypes } from '../../utils/HttpReducerHelper';

export const OPEN_QUESTIONNAIRE = createType('MARKETPLACE', 'OPEN_QUESTIONNAIRE');
export const CLOSE_QUESTIONNAIRE = createType('MARKETPLACE', 'CLOSE_QUESTIONNAIRE');
export const apiKey = generateTypes('MARKETPLACE', 'API_KEY');
export const profileId = generateTypes('MARKETPLACE', 'PROFILE_ID');
export const questionnairePrefill = generateTypes('MARKETPLACE', 'QUESTIONNAIRE_PREFILL');
export const questionnaireMatchesResults = generateTypes('MARKETPLACE', 'MATCHES_RESULTS');
